import { getParams } from '../../utils/searchParams';
import { FullscreenError } from '../../components/FullscreenError/FullscreenError';
import { Layout } from '../../components/Layout/Layout';
import { RequestDetails } from '../../components/RequestDetails/RequestDetails';
import { Loader } from '@repo/ui/Loader';
import { Flex } from '@repo/ui/Flex';
import { useQuery } from '@tanstack/react-query';
import { QUERIES } from '../../utils/constants';
import { getClaimQueryFn } from '../../graphql/query/getClaim';
import { formatToShort } from '../../utils/dates';
import { PageWrap } from '../../components/Page/Page';
import { Promo } from '../../components/Promo/Promo';

export const ClaimDetails = () => {
  const claimId = getParams()?.claimId as string;
  const order = getParams()?.order as string;

  const {
    isError,
    isLoading,
    data: submittedRequestsData,
  } = useQuery({
    queryKey: [QUERIES.GET_CLAIM, claimId],
    queryFn: () => getClaimQueryFn(claimId),
    retry: false,
  });

  if (isError) {
    return (
      <PageWrap>
        <Flex grow="1" justifyContent="center" alignItems="center">
          <FullscreenError
            title={{
              langKey: [
                'Global.claimLookup.error.title',
                'Global.fullscreenError.title',
              ],
            }}
            description={{
              langKey: [
                'Global.claimLookup.error.description',
                'Global.fullscreenError.description',
              ],
            }}
          />
        </Flex>
      </PageWrap>
    );
  }

  if (isLoading || !submittedRequestsData) {
    return (
      <PageWrap>
        <Flex grow="1" justifyContent="center" alignItems="center">
          <Loader size="lg" label="Loading..." />
        </Flex>
      </PageWrap>
    );
  }

  const {
    submitDate,
    deliveryType,
    items,
    packagingOption,
    shipments,
    status,
    location,
  } = submittedRequestsData.claim;

  const orderNumberFromItems =
    items.length > 0 &&
    items.every((item) => item.orderNumber === items?.[0]?.orderNumber)
      ? items?.[0]?.orderNumber
      : '';

  const replacementTokens = {
    submittedDate: (submitDate && formatToShort(submitDate)) ?? '',
    deliveryMethodType: deliveryType,
    itemCount: `${items.length}`,
    orderNumber: order ?? orderNumberFromItems,
  };

  return (
    <PageWrap>
      <Layout>
        <Promo id={'claimDetails.pageTop'} />
        <RequestDetails
          confirmationEmail={false}
          headerTitle={{
            langKey: [
              'Global.claimDetails.header.title',
              'Global.requestDetails.header.title',
            ],
            replacementTokens,
          }}
          headerSubtitle={{
            langKey: [
              'Global.claimDetails.header.subtitle',
              'Global.requestDetails.header.subtitle',
            ],
            replacementTokens,
          }}
          data={{
            requestItems: items,
            deliveryType,
            deliveryMethod: { packagingOption },
            label: shipments[0] ? { url: shipments[0].labelUrl } : null,
            qrCode: shipments[0] ? { url: shipments[0].qrCodeUrl } : null,
            status: status ?? 'REQUEST_COMPLETE',
            location,
          }}
        >
          <Promo id={'claimDetails.pageBottom'} />
        </RequestDetails>
      </Layout>
    </PageWrap>
  );
};
